module.exports = __webpack_public_path__ + "static/media/13.83499c2c.jpg";